import {type InvoiceExportIncludes} from 'web-app/util/graphql/api-types';

// These enum and types can be modified later when we have more info
export enum ExportFileStatus {
    LOADING = 'Loading',
    EXPIRED = 'File expired',
    DOWNLOAD = 'Download',
}

export type InvoiceType = 'Invoice lines' | 'Invoice items' | 'Invoices';

export type ExportFormat = 'CSV' | 'Xero CSV' | 'Sage CSV';

export type ExportStatus = 'Completed' | 'Pending' | 'Expired';

export interface InvoiceExportListItem {
    fileCreatedAt: string | null;
    invoicingDateFrom: string | null;
    invoicingDateTo: string | null;
    invoiceCreatedFrom: string | null;
    invoiceCreatedTo: string | null;
    includes: InvoiceExportIncludes;
    format: ExportFormat;
    generationId: string | null;
    downloadUrl: string | null;
    status: {
        progress: number | null;
        status: ExportStatus;
    };
}
